import {Subscript} from "../primitives/typography";

import type {SystemStyleObject} from "@styled-system/types";

export const CopyRightComponent = ({cssProp}: {cssProp?: SystemStyleObject}) => {
    return (
        <Subscript
            css={{
                fontFamily: "Barlow Condensed",
                fontSize: "md",
                fontWeight: "normal",
                ...cssProp
            }}>
            ©Copyright 2025 Jindo LLC
        </Subscript>
    );
};
